export const FeatureFlags = {
  ActivityDrawerInTablesCC: 'activityDrawerInTablesCC',
  ActivityOutcomeFieldsInForm: 'activityOutcomeFieldsInForm',
  ActivityOutcomeInlineEdition: 'activityOutcomeInlineEdition',
  AIAssistant: 'aiAssistant',
  AIAssistantSelectModels: 'aiAssistantSelectModels',
  AIGeneratorsLinkedinAIPrompt: 'aiGeneratorsLinkedinAIPrompt',
  AIProspectingAssistant: 'aiProspectingAssistant',
  AIRoleplay: 'aiRoleplay',
  AIRoleplayCreationFromList: 'aiRoleplayCreationFromList',
  AssignmentSheetCreation: 'assignmentSheetCreation',
  AssitantRegionalDirectorsOnBehalfSendoutCreation:
    'assitantRegionalDirectorsOnBehalfSendoutCreation',
  AssociatedCompaniesTree: 'associatedCompaniesTree',
  BulkEmailAI: 'bulkEmailAI',
  BulkEmailAIRecruiting: 'bulkEmailAIRecruiting',
  BulkEmailArchiveTemplates: 'archiveBulkTemplates',
  BulkEmailArchiveTemplatesFolders: 'archiveTemplatesFolders',
  BulkEmailBlockAssociatedCompanies: 'bulkBlockAssociatedCompanies',
  BulkEmailEditTemplatesFolders: 'editBulkTemplatesFolders',
  BulkEmailEnableSignatureOnSchedules: 'enableSignatureOnScheduleBulksPreview',
  BulkEmailListItemCardAILabel: 'AILabelOnBulkEmailItemCards',
  BulkEmailNewDashboardStats: 'newBulkDashboardStats',
  BulkEmailRepliedEmailsStat: 'repliedEmailsBulkStats',
  BulkEmailSequences: 'bulkEmailSequences',
  BulkEmailStatsQuickView: 'bulkemail-quickview',
  BulkShowEmailVariant: 'bulkShowEmailVariant',
  BulkSmartTagOnEmailBody: 'smartTagOnEmailBody',
  BulkSmartTagOnSubject: 'smartTagOnSubject',
  BulkStatsTablesActions: 'bulkStatsTablesActions',
  BulkTemplatesRestoreSelectingFolder: 'restoreTemplatesSelectingFolder',
  CandidateCreationFromResume: 'candidateCreationFromResume',
  CandidateDataSheetFlow: 'candidateDataSheetFlow',
  CandidateKeywordTags: 'candidateKeywordTags',
  CandidateMatchMaking: 'candidateMatchMaking',
  CandidateMatchMakingByContact: 'candidateMatchMakingByContact',
  CandidateMatchMakingByJobOrder: 'candidateMatchMakingByJobOrder',
  CandidatesKeywordsFromApplicantUrl: 'candidatesKeywordsFromApplicantUrl',
  CandidatesMultiplePhones: 'candidatesMultiplePhones',
  CandidatesPresentationMaker: 'candidatesPresentationMaker',
  CandidatesResumeTab: 'candidatesResumeTab',
  CandidatesSavedSearches: 'candidatesSavedSearches',
  CandidatesTabMultiplePhones: 'candidatesTabMultiplePhones',
  CategoryFilesSendout: 'categoryFilesSendout',
  CategoryFilesSendoutDebrief: 'categoryFilesSendoutDebrief',
  ChangeLogCandidate: 'changeLogCandidate',
  ChangeLogCompany: 'changeLogCompany',
  ChangeLogContact: 'changeLogContact',
  ChangeLogHA: 'changeLogHA',
  ChangeLogJobOrder: 'changeLogJobOrder',
  ClaimAccountabilityCandidate: 'claimAccountabilityCandidate',
  ClaimAccountabilityCompany: 'claimAccountabilityCompany',
  ClaimAccountabilityJobOrder: 'claimAccountabilityJobOrder',
  CommandCenterCommissionsBoard: 'commandCenterCommissionsBoard',
  CommandCenterDominateActiveTab: 'commandCenterDominateActiveTab',
  CommandCenterDominateEstimatedCommissions: 'commandCenterDominateEstimatedCommissions',
  CommandCenterDrillDown: 'commandCenterDrillDown',
  CommandCenterFallOffsBoard: 'commandCenterFallOffsBoard',
  CommandCenterPDA: 'commandCenterPDA',
  CommandCenterProductionBoardPage: 'commandCenterProductionBoardPage',
  CommandCenterProductionBoardTracking: 'commandCenterProductionBoardTracking',
  CommandCenterRecruiterActivity: 'commandCenterRecruiterActivity',
  CommandCenterRecruiterPilGrowth: 'commandCenterRecruiterPilGrowth',
  CommandCenterRecruiterTabs: 'commandCenterRecruiterTabs',
  CommandCenterShowVerification: 'commandCenterShowVerification',
  CommandCenterTeamPhotos: 'commandCenterTeamPhotos',
  CompaniesHeadquarterColumn: 'companiesHeadquarterColumn',
  CompaniesKeywordTags: 'companiesKeywordTags',
  CompaniesMultiplePhones: 'companiesMultiplePhones',
  CompaniesSalesTab: 'companiesSalesTab',
  CompaniesSavedSearches: 'companiesSavedSearches',
  CompaniesTargetPriority: 'companiesTargetPriority',
  ContactKeywordTags: 'contactKeywordTags',
  Contacts: 'contacts',
  ContactsDataSheetTab: 'contactsDataSheetTab',
  ContactsMultiplePhones: 'contactsMultiplePhones',
  ContactsSavedSearches: 'contactsSavedSearches',
  ConvertLegacyPhones: 'convertLegacyPhones',
  ConvertedContacts: 'redirectConvertedContacts',
  DailyPerformanceDownload: 'dailyPerformanceDownload',
  DailyPerformanceFinancialFilters: 'dailyPerformanceFinancialFilters',
  DailyPerformanceMetricsFilters: 'dailyPerformanceMetricsFilters',
  DailyPlan: 'dailyPlan',
  DailyPlanAddTaskFromProfile: 'dailyPlanAddTaskFromProfile',
  DailyPlanAddTasksFromTable: 'dailyPlanAddTasksFromTable',
  DailyPlanArchiveTasks: 'dailyPlanArchiveTasks',
  DailyPlanBulkReschedule: 'dailyPlanBulkReschedule',
  DashboardFeeAgreements: 'dashboardFA',
  DashboardPhone: 'dashboardPhone',
  DashboardSendoutLeaders: 'dashboardsendoutleaders',
  DashboardSendoutMetrics: 'dashboardsendoutmetrics',
  DashboardSendouts: 'dashboardsendouts',
  DashboardToolsUsageReport: 'dashboardtoolsusagereport',
  DashboardToolsUsageReportV2: 'dashboardtoolsusagereportV2',
  DisableQuickViewSwitch: 'quickViewSwitch',
  Drafts: 'drafts',
  EmailValidationColumn: 'emailValidationColumn',
  EmailVerdictV2: 'emailVerdictV2',
  EmailWithValidationColumnCandidates: 'emailWithValidationColumnCandidates',
  EmailWithValidationColumnNames: 'emailWithValidationColumnNames',
  EmailWithValidationColumnSearchProjectPreviews: 'emailWithValidationColumnSearchProjectPreviews',
  EmployeesMultiplePhones: 'employeesMultiplePhones',
  EnableActionsTab: 'enableNotesActionsTab',
  EnableQuickViewNavigation: 'enableQuickViewNavigation',
  EnableRemoveInBulkTables: 'enableRemoveInBulkTables',
  ExpandableTables: 'expandableTables',
  ExternalFeeAgreement: 'externalFA',
  FeeAgreement: 'feeagreement',
  FeeAgreementsSplitPayments: 'fa-split-payments',
  FeedbackNotes: 'feedbackNotesDrawer',
  FeedbackNotesImagesSuport: 'feedbackNotesImagesSupport',
  FeedbackNotesSaveInEmployeeFile: 'feedbackNotesSaveInEmployeeFile',
  FileManager: 'fileManager',
  FilterByActivitiesInSearchProjects: 'filterByActivitiesInSearchProjects',
  FilterByBusinessInvolvement: 'filterByBusinessInvolvement',
  FilterByBusinessInvolvementSearchProjects: 'filterByBusinessInvolvementSearchProjects',
  FilterByCandidateAccountableOfHotSheet: 'filterByCandidateAccountableOfHotSheet',
  FilterByCandidateActivities: 'filterByCandidateActivities',
  FilterByCompanyActivities: 'filterByCompanyActivities',
  FilterByCompanyLegalName: 'filterByCompanyLegalName',
  FilterByContactActivities: 'filterByContactActivities',
  FilterByFeeAgreementPaymentScheme: 'filterByFeeAgreementPaymentScheme',
  FilterByJobOrderAccountableOfHotSheet: 'filterByJobOrderAccountableOfHotSheet',
  FilterByJobOrderActivities: 'filterByJobOrderActivities',
  FilterByNumberOfContactsRange: 'filterByNumberOfContactsRange',
  FilterByNumberOfEmployeesRange: 'filterByNumberOfEmployeesRange',
  FilterByRevenueRange: 'filterByRevenueRange',
  FollowUpTasks: 'followUpTasks',
  FreeGameButtons: 'FreeGameButtons',
  HaFeeAgreementTab: 'haFeeAgreementTab',
  HaJobOrderTab: 'haJobOrderTab',
  HaPlacementsTab: 'haPlacementsTab',
  HiringAuthoritiesMultiplePhones: 'hiringAuthoritiesMultiplePhones',
  HiringExtendedLocationSearch: 'hiringExtendedLocationSearch',
  Home: 'newHome',
  HomeMultipleRegions: 'homeMultipleRegions',
  IndustriesViewer: 'industriesViewer',
  IndustryEmailBCCSendout: 'industryEmailBCCSendout',
  JobOrderColumnMultipleHA: 'jobOrderColumnMultipleHA',
  JobOrderColumnsHAProfile: 'jobOrderColumnsHAProfile',
  JobOrderDataSheetFlow: 'jobOrderDataSheetFlow',
  JobOrderJobDescription: 'jobOrderJobDescription',
  JobOrderKeywordTags: 'jobOrderKeywordTags',
  JobOrderMatchMaking: 'jobOrderMatchMaking',
  JobOrderMatchMakingByApplicant: 'jobOrderMatchMakingByApplicant',
  JobOrderMatchMakingByCandidate: 'jobOrderMatchMakingByCandidate',
  JobOrderPresentationMaker: 'jobOrderPresentationMaker',
  JobOrderSavedSearches: 'jobOrderSavedSearches',
  KeywordPickerSplitByComma: 'keywordPickerSplitByComma',
  KeywordSearch: 'keywordsearch',
  LinkCompanies: 'linkCompanies',
  LogRocket: 'logrocket',
  MapSubspecialtyFilter: 'map_subspecialty_filter',
  MenuNavBar: 'menunavbar',
  MessageCenter: 'messageCenter',
  MessageCenterDrawerChat: 'messageCenterDrawerChat',
  MessageCenterFilters: 'messageCenterFilters',
  MessageCenterNotifications: 'messageCenterNotifications',
  MessageCenterSelectMessages: 'messageCenterSelectMessages',
  MessageCenterSendToUnsavedContact: 'messageCenterSendToUnsavedContact',
  MessageCenterTemplates: 'messageCenterTemplates',
  MultiplePhonesColumn: 'multiplePhonesColumn',
  MultiplePhonesWithCommunicationActions: 'multiplePhonesWithCommunicationActions',
  MutiplePhonesListingTags: 'mutiplePhonesListingTags',
  NewCandidateFromContact: 'newCandidateFromContact',
  NewCandidateTalentPoolValidation: 'newCandidateTalentPoolValidation',
  NewCandidateV2: 'newCandidateV2',
  NewHiringAuthorityTabs: 'newHiringAuthorityTabs',
  NoHireLetter: 'noHireLetter',
  Notifications: 'notifications',
  OpenToRelocationFilter: 'openToRelocationFilter',
  OptOutFilter: 'optOutFilter',
  OrganizeTabsCandidateProfile: 'organizeTabsCandidateProfile',
  OrganizeTabsCompanyProfile: 'organizeTabsCompanyProfile',
  OrganizeTabsContactProfile: 'organizeTabsContactProfile',
  OrganizeTabsHAProfile: 'organizeTabsHAProfile',
  OrganizeTabsJobOrderProfile: 'organizeTabsJobOrderProfile',
  OtherEmailValidationProfiles: 'otherEmailValidationProfiles',
  OverallPerformanceDownload: 'overallPerformanceDownload',
  OverallPerformanceFeedbackActivityColumns: 'overallPerformanceFeedbackActivityColumns',
  OverallPerformanceFinancialFilters: 'overallPerformanceFinancialFilters',
  OverallPerformanceMetricsFilters: 'overallPerformanceMetricsFilters',
  OverallPerformanceSecondVersion: 'overallPerformanceSecondVersion',
  PersonalEmailVerdictFilter: 'personalEmailVerdictFilter',
  PhoneDashboardTotalCalls: 'phoneDashboardTotalCalls',
  PilDescriptions: 'pilDescriptions',
  PlacementCollections: 'placement-collections',
  PlacementDeletePermanently: 'placementDeletePermanently',
  PlacementPaymentsFromNetsuite: 'placement-paymets-from-netsuite',
  PlacementRequestFeeOrGuaranteeChanges: 'placementRequestFeeOrGuaranteeChanges',
  PlacementSavedSearches: 'placementSavedSearches',
  PlacementWithAssignmentDataSheet: 'placement-data-sheet',
  PlacementWithEstimates: 'placement-estimates',
  PlacementWithReferences: 'placement-references',
  ProfileLayout: 'profileLayout',
  ProfileNavigationControls: 'profileNavigationControls',
  RecruiterProfileNotes: 'recruiterProfileNotes',
  ReferenceCheckAISummary: 'referenceCheckAISummary',
  ReferenceCheckDownload: 'referenceCheckDownload',
  ResendEmailHiringAuthoritySendout: 'resendEmailHiringAuthoritySendout',
  ResumeSearch: 'resumeSearch',
  SavedSearchesDate: 'savedSearchesDate',
  SearchProjectPreviewMultiplePhones: 'searchProjectPreviewMultiplePhones',
  SearchProjectsArchiveMultiple: 'archiveMultipleSearchProjects',
  SearchProjectsChangeOwner: 'changeSearchProjectOwner',
  SearchProjectsExtractCompaniesContacts: 'extractSearchProjectCompaniesContacts',
  SearchProjectsFolders: 'searchProjectsFolders',
  SearchProjectsMasterListFields: 'masterListFields',
  SearchProjectsRefactor: 'searchProjectsRefactor',
  SendBulkViaOutlook: 'sendBulkViaOutlook',
  SendoutDuplicates: 'sendoutDuplicates',
  Sendouts: 'sendouts',
  SendoutsV2: 'sendoutsV2',
  SendoutsChannelPartner: 'sendoutsChannelPartner',
  SendoutsInterviewDetailsActions: 'sendoutsInterviewDetailsActions',
  SendoutsSavedSearches: 'sendoutsSavedSearches',
  SendoutStatusReasonsFilter: 'sendoutStatusReasonsFilter',
  SendoverHAReminder: 'sendoverHAReminder',
  SharedSavedSearches: 'sharedSavedSearches',
  SidebarV2: 'sidebarV2',
  SigningBackupService: 'signingBackup',
  SpecificPILLocation: 'specificPILLocation',
  SupportActivity: 'supportActivity',
  TalentPoolLink: 'talentPoolLink',
  UrgencyVerification: 'urgencyVerification',
  WebsiteFilter: 'websiteFilter'
};
